module.exports = ":host {\r\n    display: block;\r\n    width: 100%;\r\n}\r\n\r\nui-carousel {\r\n    display: block;\r\n    margin: 0 auto;\r\n}\r\n\r\n.text {\r\n    text-align: center;\r\n    line-height: 300px;\r\n    font-size: 40px;\r\n    color: #fff;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/finite-carousel/finite-carousel.component.css
// module id = ./src/app/finite-carousel/finite-carousel.component.css
// module chunks = main